/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionsListFacets } from "../funcs/userSessionsListFacets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListUserSessionFacetsResult } from "../models/components/listusersessionfacetsresult.js";
import {
  ListUserSessionFacetsRequest,
  ListUserSessionFacetsSecurity,
} from "../models/operations/listusersessionfacets.js";
import { unwrapAsync } from "../types/fp.js";
export type UserSessionFacetsQueryData = ListUserSessionFacetsResult;

export function prefetchUserSessionFacets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionFacetsRequest | undefined,
  security?: ListUserSessionFacetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionFacetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildUserSessionFacetsQuery(
  client$: GramCore,
  request?: ListUserSessionFacetsRequest | undefined,
  security?: ListUserSessionFacetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionFacetsQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionFacets({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionFacetsQueryFn(
      ctx,
    ): Promise<UserSessionFacetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionsListFacets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyUserSessionFacets(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessions", "listFacets", parameters];
}
